/* eslint-disable react/jsx-no-target-blank */
import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import logo from "../../../images/full-stack-development.gif";
import { Button, Grid } from "@mui/material";
import { Box } from "@mui/system";
import DownloadIcon from '@mui/icons-material/Download';
import BgAnimation from "./BackgroundAnimation";
const theme = createTheme();

theme.typography.h4 = {
  fontSize: "21px",
  "@media (min-width:600px)": {
    fontSize: "26px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "32px",
  },
};
theme.typography.body1 = {
  fontSize: "16px",
  "@media (min-width:600px)": {
    fontSize: "18px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "20px",
  },
};

const Home = () => {
  return (
    <Box id="home" sx={{ pt: 3 }}>
      <Grid container spacing={2}>
        <Grid
          item
          md={3}
          sx={{ display: { xs: "none", md: "flex" } }}
        >
          <BgAnimation />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Card className="CardBG" sx={{ mt: "32px", boxShadow: 0 }}>
            <CardMedia
              sx={{ maxWidth: 1500, margin: "auto" }}
              component="img"
              // height="140"
              image={logo}
              alt="green iguana"
            />
            <CardContent sx={{ p: 0, mt: 1 }}>
              <ThemeProvider theme={theme}>
                <Typography
                  gutterBottom
                  variant="h4"
                  component="div"
                  className="cardtextwhite"
                  sx={{ textAlign: "center", mt: 5 }}
                >
                  Hello, I'm KAZI ABDUR RAKIB. <br /> FULL STACK WEB DEVELOPER
                </Typography>

                <Box sx={{ textAlign: "center", fontWeight: "bold", mt: 2 }}>
                  <Button className="button-beguni" variant="contained">
                    <DownloadIcon sx={{ m: 1 }} />
                    <a
                      style={{ textDecoration: "none", color: "white" }}
                      target="_blank"
                      href="https://drive.google.com/file/d/1L7FjGbtWRb0YnJtNtLjvFtEqlKuRaM-2/view?usp=sharing"
                      rel="noreferrer"
                    >
                      <Typography variant="body1">DOWNLOAD RESUME</Typography>
                    </a>
                  </Button>
                </Box>
              </ThemeProvider>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          md={3}
          sx={{ display: { xs: "none", md: "flex" } }}
        >
          <BgAnimation />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;
